module.exports = __webpack_public_path__ + "img/introSafe.bb15a49d.png";